/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClientList, getLocations } from 'store/clientSlice';
import { searchVendorFiltersV2 } from 'store/vendorSliceV2';
import { getUIVersion } from 'utils/router-static-data';
import { Box } from 'atoms';
import { VendorBillGenerationForm } from 'components/forms';
import { search_type } from 'utils';

export default function CreateClientContractPage() {
	const { cities = [], statesWithCites } = useSelector((state) => state.clientState);
	const [vendor_data, SetVendors] = useState('');
	const uiVersion = getUIVersion();
	const useV2API = uiVersion === 'new';

	console.log('statesWithCites', statesWithCites);
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(
			getLocations({
				search_type: search_type?.location,
				filter_by: {},
			})
		);

		if (useV2API) {
			dispatch(
				searchVendorFiltersV2({
					filter_by: { is_active: true },
					limit: 1000,
				})
			).then((ven_res) => {
				const venData = (ven_res?.results || []).map((item) => ({
					label: item?.label || item?.vendor_name,
					value: item?.value || item?.id,
				}));
				SetVendors(venData);
			});
		} else {
			dispatch(
				getClientList({
					search_type: 'vendor',
					filter_by: {
						is_active: true,
					},
				})
			).then((ven_res) => {
				console.log(ven_res);
				const venData = ven_res?.data?.map((item) => ({
					label: item?.vendor_info?.vendor_name,
					value: item?.id,
				}));
				SetVendors(venData);
			});
		}
	}, [dispatch, useV2API]);
	console.log(cities);
	return (
		<Box>
			<VendorBillGenerationForm cities={cities} vendor_data={vendor_data} />
		</Box>
	);
}
